import glsl from "glslify";
import { mat4 } from "lib/vec-math";
import * as quads from "lib/quads";
import { accessors, drawCommand } from "lib/regl-helpers";
import { matcap } from "lib/shaders";
import { createWithModel } from "lib/draw/with-model";
const simplex = new (require("simplex-noise"))();
export function createMask(regl, maskMesh, overrides = {}) {
    return {
        drawMask: createDrawMask(regl, maskMesh, overrides),
        withMaskModel: createWithMaskModel(regl),
    };
}
function createWithMaskModel(regl) {
    const out = mat4.create();
    const eye = [0, 0, -1];
    const center = [0, 0, 0];
    const up = [0, 1, 0];
    return createWithModel(regl, "head", ({ time }) => {
        center[0] = simplex.noise2D(time * 0.1, 0) * 0.05;
        center[1] = simplex.noise2D(time * 0.1, 10) * 0.025;
        up[0] = simplex.noise2D(time * 0.1, 10) * 0.25;
        eye[0] = simplex.noise2D(time * 0.05, 0) * 0.25;
        // return mat4.identity(out)
        return mat4.lookAt(out, center, eye, up);
    });
}
function createDrawMask(regl, mesh, overrides) {
    const { getProp, getContext } = accessors();
    return drawCommand(regl, {
        name: "drawMask",
        vert: glsl `
      precision highp float;
      uniform vec3 cameraPosition;
      attribute vec3 normal, position;
      uniform float time; // Used in overrides.
      uniform mat3 viewNormal, modelNormal;
      uniform mat4 model, projView;
      varying vec3 vNormal, vViewPosition, vPosition;
      ${overrides.vertHeader || ""}

      void main() {
        vNormal = viewNormal * modelNormal * normal;

        // Do not rename.
        vec3 morphed = position;
        ${overrides.vertBody || ""}
        vec4 worldPosition = model * vec4(morphed, 1.0);
        vPosition = position;
        vViewPosition = cameraPosition - worldPosition.xyz;
        gl_Position = projView * worldPosition;
      }
    `,
        frag: glsl `
      precision highp float;
      ${matcap}
      uniform sampler2D matcapTexture;
      uniform float time;
      varying vec3 vNormal, vViewPosition, vPosition;
      ${overrides.fragHeader || ""}

      void main() {
        vec2 uv = matcap(normalize(vViewPosition), normalize(vNormal));
        vec3 color = texture2D(matcapTexture, uv).rgb;
        ${overrides.fragBody || ""}
        gl_FragColor = vec4(color, 1.0);
      }
    `,
        attributes: {
            position: mesh.positions,
            normal: mesh.normals,
        },
        uniforms: {
            matcapTexture: getProp("matcapTexture"),
            model: getContext("headModel"),
            modelNormal: getContext("headModelNormal"),
        },
        elements: quads.getElements(mesh, "triangle"),
        primitive: "triangles",
        cull: { enable: true },
    });
}
